namespace TabAurous.Inventory {
    export interface SortingItemsForm {
        TransItemId: Serenity.StringEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        CertificateNo: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        DesignId: Serenity.StringEditor;
        DesignCode: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        SieveId: StoneSieveLookup;
        GroupSieveId: StoneSieveLookup;
        QualityId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        GrossAmount: Serenity.DecimalEditor;
        CCNetAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        Line_No: Serenity.StringEditor;
        Hsn: Serenity.StringEditor;
        NetWeight: WeightEditor;
        CalcOnId: Serenity.IntegerEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        SpecialRemark: Serenity.StringEditor;
        UserDescription: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        DeliveryDate: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        BagStatus: Serenity.StringEditor;
        ImageName: Serenity.ImageUploadEditor;
    }

    export class SortingItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.SortingItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SortingItemsForm.init)  {
                SortingItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = CommonSubCategoryLookup;
                var w5 = StoneSieveLookup;
                var w6 = WeightEditor;
                var w7 = s.DecimalEditor;
                var w8 = s.DateEditor;
                var w9 = s.ImageUploadEditor;

                Q.initFormType(SortingItemsForm, [
                    'TransItemId', w0,
                    'BagNo', w0,
                    'SKU', w0,
                    'LotNo', w0,
                    'CertificateNo', w0,
                    'RefNo', w0,
                    'ItemTypeId', w1,
                    'ProductId', w0,
                    'ProductCode', w0,
                    'ProductName', w0,
                    'DesignId', w0,
                    'DesignCode', w0,
                    'AttributeId', w0,
                    'ProductTypeId', w2,
                    'CategoryId', w3,
                    'SubCategoryId', w4,
                    'SieveId', w5,
                    'GroupSieveId', w5,
                    'QualityId', w2,
                    'ShapeId', w2,
                    'StoneColorId', w2,
                    'StoneSizeId', w2,
                    'Pieces', w1,
                    'Weight', w6,
                    'GrossAmount', w7,
                    'CCNetAmount', w7,
                    'CCGrossAmount', w7,
                    'Line_No', w0,
                    'Hsn', w0,
                    'NetWeight', w6,
                    'CalcOnId', w1,
                    'RefTransItemId', w0,
                    'RefTransId', w0,
                    'Remark', w0,
                    'SpecialRemark', w0,
                    'UserDescription', w0,
                    'AckStatus', w1,
                    'DeliveryDate', w8,
                    'CompanyId', w1,
                    'BagStatus', w0,
                    'ImageName', w9
                ]);
            }
        }
    }
}
